import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { Utils } from '../util/utils'

export class OpMobileNetworkCode implements IReferenceType, IOpChangeState, IJsonSerializable {
    //Properties
    public code: number
    public mmc: string
    public mnc: string
    public brand: string
    public operator: string
    public bands: string
    public smsServiceCenter: string
    public apnAddress: string
    public apnLogin: string
    public apnPassword: string
    //Properties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdMobileNetworkCode
    }
    public getReferenceKey(): number {
        return this.code
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.code = opObj.C
                this.mmc = opObj.MM
                this.mnc = opObj.MN
                this.brand = opObj.B
                this.operator = opObj.OP
                this.bands = opObj.BA
                this.smsServiceCenter = opObj.S
                this.apnAddress = opObj.A
                this.apnLogin = opObj.AL
                this.apnPassword = opObj.AP
                this.opState = opObj.O
            } else {
                this.code = opObj.CODE
                this.mmc = opObj.MMC
                this.mnc = opObj.MNC
                this.brand = opObj.BRAND
                this.operator = opObj.OPERATOR
                this.bands = opObj.BANDS
                this.smsServiceCenter = opObj.SMS_SERVICE_CENTER
                this.apnAddress = opObj.APN_ADDRESS
                this.apnLogin = opObj.APN_LOGIN
                this.apnPassword = opObj.APN_PASSWORD
                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                C: this.code,
                MM: this.mmc,
                MN: this.mnc,
                B: this.brand,
                OP: this.operator,
                BA: this.bands,
                S: this.smsServiceCenter,
                A: this.apnAddress,
                AL: this.apnLogin,
                AP: this.apnPassword,
                O: this.opState,
                __IC: 1
            }
        } else {
            return {
                CODE: this.code,
                MMC: this.mmc,
                MNC: this.mnc,
                BRAND: this.brand,
                OPERATOR: this.operator,
                BANDS: this.bands,
                SMS_SERVICE_CENTER: this.smsServiceCenter,
                APN_ADDRESS: this.apnAddress,
                APN_LOGIN: this.apnLogin,
                APN_PASSWORD: this.apnPassword,
                OpState: this.opState
            }
        }
    }

    public toString() {
        var s = ''
        if (!Utils.isNullOrWhitespace(this.operator))
            s += this.operator + ' '
        if (!Utils.isNullOrWhitespace(this.brand))
            s += '[' + this.brand + '] '
        s += this.code
        return s
    }
}